module.exports = __webpack_public_path__ + "img/EditOutlined.6fd74a14.svg";